import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Observable } from "rxjs/Observable";
import { Constants } from "../../helper/constants";
import { AccountService } from "../account/account.service";

@Injectable()
export class NotificationService {
  private userId: string;

  constructor(private accountService: AccountService, private db: AngularFireDatabase) {
    this.userId = this.accountService.getUserId();
  }

  getNotifications(communityId, userId): Observable<any> {
    const $result = this.db.object(`/test_notifications/${userId}/${communityId}/Community Manager`)
    .valueChanges();

    return $result.map(snapshot => {
      if (snapshot) {
        const notificationIds = Object.keys(snapshot);
        let notifications = Object.values(snapshot);
        notifications = notifications.filter(notification => (notification.type === Constants.BILL_TYPE_NOTIFICATION) ||
        (notification.type === Constants.PAYMENT_NOTIFICATION));
        notifications =  notifications.map((notification, index) => {
          return {
            id: notification.id || notificationIds[index],
            isRead: notification.isRead || false,
            title: notification.data.message,
            authorId: notification.userId,
            action: notification.data.action,
            type: notification.type,
            date: notification.time,
            entityId: notification.data.id,
            communityId: notification.communityId
          };
        });
  
        return notifications;
      }
    });
  }

  markNotificationAsRead(communityId, notificationId, userId): boolean {
    const res = this.db.list(`/test_notifications/${userId}/${communityId}/Community Manager/`).update(notificationId, {isRead: true});

    return !!res;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/notification.service.ts